
import { Component, Vue, Prop } from "vue-property-decorator";
import Bus from "@/lib/Bus";
const bus: Bus = new Bus().getBus();


import { Store, CompoPersonList, Ctx, Compo, CompoPerson} from './CompoPerson'; // Adjust the path to your actual file location

export class Person {
    public _id:any
    public name: string=""
    public age: number = 33
}


export class PersonStore extends Store {
   

    static running =0

    static async obj() {
        const person=new Person()
        person._id =Store.get_id()
        person.name='Adam'
        person.age=33;
       
        const person1=new Person()
        person1._id =Store.get_id()
        person1.name='Eva'
        person1.age=30;
         
        await new Promise(resolve => setTimeout(resolve, 500));
        
        const person_list = [person, person1]
        const person_group = {    name: 'Group name',    persons: person_list   }

        return person_group
    }

    static async addPersonHandler(ctx:Ctx) {
       console.log(`handler XXX addPerson called for ${ctx.path}`);
       const newPerson = new Person();
       await new Promise(resolve => setTimeout(resolve, 500));
       newPerson._id = Store.get_id()
       ctx.obj.push(newPerson);
       console.log(ctx)
       //await Compo.render(ctx, CompoPersonList.html, CompoPersonList.reactive)
       await Compo.addObjectToListOK({...ctx, obj:newPerson})
    }


    static async delPersonHandler(ctx:Ctx) {
      
      ctx.obj = (ctx.obj as any[]).filter(item => item._id !== ctx._id);
      await new Promise(resolve => setTimeout(resolve, 500));
      await Compo.deleteObjectFromListOK(ctx)
      //await Compo.render(ctx, CompoPersonList.html, CompoPersonList.reactive)
      console.log("delete end")
    }

    static async chgPersonHandler(ctx:Ctx) {
      
      ctx.obj = (ctx.obj as any[]).filter(item => item._id !== ctx._id);

      await new Promise(resolve => setTimeout(resolve, 500));
      
      await Compo.deleteObjectFromListOK(ctx)
      //await Compo.render(ctx, CompoPersonList.html, CompoPersonList.reactive)
      console.log("delete end")
    }

    static inc_running( path: string, prop:string) {
      PersonStore.running++
      console.log("RUNNING",path, prop,PersonStore.running)
    }

    static dec_running( path: string, prop:string) {
      PersonStore.running--
      console.log("RUNNING",path, prop,PersonStore.running)
    }

    static async nameChgHandler(ctx:Ctx) {
      
      PersonStore.inc_running(ctx.path, ctx.prop)
      await new Promise(resolve => setTimeout(resolve, 1000));
      //await Compo.render(ctx, CompoPerson.html)

      if (PersonStore.running==1) {
        await Compo.changeObjectValueOK(ctx)
        console.log("saved")
      }
      PersonStore.dec_running(ctx.path, ctx.prop)
      console.log("CHANGE end")
    }


}




@Component({ components: { } })
export default class CompoTestVue extends Vue { 
    
    async mounted() { 

        
        const obj = await PersonStore.obj()

        const ctx:Ctx = { obj:obj.persons, path:'persons', list:[], _id:null, element:'', prop:'persons', value:null}
       
        await Compo.render({...ctx, element: 'el_group1'}, CompoPersonList.html) 
        await Compo.render({...ctx, element: 'el_group2'}, CompoPersonList.html) 

        Compo.addButtonHandlers({...ctx, element: 'el_group1'}, { addPersonHandler:PersonStore.addPersonHandler, delPersonHandler:PersonStore.delPersonHandler});     
        Compo.addInputHandlers({...ctx, element: 'el_group1'},  { chgPersonHandler:PersonStore.chgPersonHandler, nameChgHandler: PersonStore.nameChgHandler});     
    } 



}
